const EPSILON = Number.EPSILON || Number.MIN_VALUE;

const relativeToPercentage = (value) => 
  // Parses 0-1 value to percentage, rounding to 2 decimals
   Math.round((Number(value) + EPSILON) * 10000) / 100
;

export default relativeToPercentage;
